import ControlGroup from '../../forms/ControlGroup';
import TextInput from '../../forms/controls/TextInput';
import DataAttributes from '../../forms/DataAttributes';
import getCurrencyConfiguration from '../../tnew/currency/getCurrencyConfiguration';
import parseMoneyInput from '../../tnew/currency/parseMoneyInput';
import EditableZonePriceInputChangehandler from './EditableZonePriceInputChangehandler';

class CustomAmountInput {
  changeHandler: EditableZonePriceInputChangehandler;

  controlGroup: ControlGroup;

  control: TextInput;

  minimumAmount: number;

  constructor($controlGroup: HTMLElement, onUpdate: () => void) {
    const id = $controlGroup.getAttribute(DataAttributes.ControlGroupFor)!;

    const $amountInput = $controlGroup.querySelector<HTMLInputElement>('.tn-ticket-selector__custom-amount-input')!;

    this.minimumAmount = parseFloat($amountInput.getAttribute('data-tn-minimum-amount') || '0');

    this.control = new TextInput([$amountInput]);

    this.changeHandler = new EditableZonePriceInputChangehandler(this.control, this.minimumAmount, onUpdate);

    this.controlGroup = new ControlGroup(id, $controlGroup, this.control);
  }

  getValue() {
    const { app } = window.tnew;

    const currencyConfig = getCurrencyConfiguration(
      app.bcp47LanguageTag,
      app.iso4217CurrencyCode,
    );

    const { amount, isValid, isEmpty } = parseMoneyInput(this.control.value, currencyConfig.thousandsSeparator, currencyConfig.decimalSeparator);

    const isMinimumAmountMet = !isEmpty && amount >= this.minimumAmount;
    return {
      amount,
      isEmpty,
      isMinimumAmountMet,
      isValid,
      rawValue: this.control.value
    };
  }

  showError = (message: string) => {
    this.controlGroup.showError(message);
  };

  clearErrors = () => {
    this.controlGroup.clearErrors();
  };

  startListening = () => {
    this.changeHandler.start();
  };

  stopListening = () => {
    this.changeHandler.stop();
  };
}

export default CustomAmountInput;
